import React, {RefObject} from "react";
import {Form, FormInstance, Switch, Tabs, Tooltip} from "antd";
import IContainerOptions from "../../../../../../model/interface/form/elementOptions/IContainerOptions";
import IFormStructureNode from "../../../../../../model/interface/form/IFormStructureNode";
import ConditionEditor from "./ConditionEditor";
import WidgetContainerEditor from "../../../widget/optionEditor/ContainerEditor";
import Title from "antd/es/typography/Title";
import IField from "../../../../../../model/interface/dataStorage/IField";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import FilterTreeBuilder from "../../../../view/settings/customFilters/FilterTreeBuilder";
import IBaseProps from "../../../../../../model/interface/IBaseProps";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";

interface IProps extends IBaseProps {
    options: IContainerOptions,
    formRef: RefObject<FormInstance>
    fieldNodes: IFormStructureNode[]
    fields: IField[]
    contentType: IContentType
}

class ContainerEditor extends React.Component<IProps> {

    render() {
        const {fields, fieldNodes, options, match, history, contentType} = this.props

        return (
            <WidgetContainerEditor {...this.props}>
                <Form.Item name={'collapsable'} label={'Možnost skrýt'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                {options.collapsable && (
                    <div>
                        <Title level={4}><LocaleText code={'configuration.widget.container.options.collapse-conditions'}
                                                     fallback={'Podmínky skrytí'}/></Title>
                        <Tabs>
                            <Tabs.TabPane key={'local'} tab={<Tooltip title={<LocaleText code={'configuration.widget.container.options.local-collapse-conditions.tooltip'} fallback={'Lokální vyhodnocení'}/>}><LocaleText code={'configuration.widget.container.options.local-collapse-conditions'} fallback={'Jednoduché'}/></Tooltip>}>
                                {options.conditions?.length > 0 && (
                                    <Form.Item name={'conditions'} noStyle={true}>
                                        <ConditionEditor fields={fields} fieldNodes={fieldNodes}/>
                                    </Form.Item>
                                )}
                                <Form.Item name={'localConditions'} noStyle={true}>
                                    <FilterTreeBuilder match={match} history={history} contentTypeFullClassName={contentType.fullClassName} maxDepth={1}/>
                                </Form.Item>
                            </Tabs.TabPane>
                            <Tabs.TabPane key={'remote'} tab={<Tooltip title={<LocaleText code={'configuration.widget.container.options.remote-collapse-conditions.tooltip'} fallback={'Vyhodnocení serveru'}/>}><LocaleText code={'configuration.widget.container.options.remote-collapse-conditions'} fallback={'Rozšířené'}/></Tooltip>}>
                                <Form.Item name={'remoteConditions'}>
                                    <FilterTreeBuilder contentTypeFullClassName={contentType.fullClassName}
                                                       originalContentTypeFullClassName={contentType.fullClassName}
                                                       match={match} history={history}/>
                                </Form.Item>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>

                )}
            </WidgetContainerEditor>
        )
    }
}

export default ContainerEditor